import { PatternFormat } from "react-number-format";
import { useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "components/ui/select";
import { usePostRecruit } from "hooks/morning/usePostRecruit";
import { RouteTypes, toastErrorSyle } from "hooks/utils/util";
import { ReactComponent as ArrowDown } from "assets/morning/icon/arrowDownNavy.svg";

const cars = ["1톤(퀵)", "1톤탑차", "3.5톤", "3벤", "다마스", "다마스(퀵)", "라보탑", "오토바이(퀵)", "차량없음"];
const initialFormState = {
    category: "morning",
    m_name: "",
    m_age: "",
    m_tel: "",
    m_area: "",
    m_car: "",
    m_up: "",
    m_time: "",
    contents: "",
};

const Recruit = ({ type }: { type: RouteTypes }) => {
    const { mutate } = usePostRecruit();
    const [formState, setFormState] = useState(initialFormState);

    const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const isFormEmpty = Object.values(formState).some(value => {
            if (typeof value === "string") {
                return value.trim() === "";
            }
            return !value;
        });

        if (isFormEmpty) {
            toast.error("입력 필드를 모두 채워해주세요.", toastErrorSyle);
            return;
        }

        mutate(formState, {
            onSuccess: () => {
                toast.success("성공적으로 지원 되었습니다.");
                setFormState(initialFormState);
            },
            onError: (error: any) => {
                console.error(error);
                const message = error.message;
                toast.error(message, toastErrorSyle);
            },
        });
    };

    return (
        <>
            <div className="flex-1 bg-[#f4f4f4] flex flex-col items-center pb-16 pt-5 responsive1200:pt-0 responsive1200:px-[4%]">
                <p className="py-[35px] text-[#333] text-[28px] font-[600] responsive1200:py-[30px] responsive1200:text-[24px]">채용지원</p>
                <div className="bg-white w-full max-w-[600px] p-[50px] flex flex-col responsive1200:px-[4%]">
                    <form onSubmit={onSubmit}>
                        <div className="flex flex-col gap-[10px] w-full mx-auto mb-[30px]">
                            <div className="flex items-center flex-wrap gap-y-1">
                                <label htmlFor="m_name" className="min-w-[100px]">
                                    이름
                                </label>
                                <input
                                    type="text"
                                    id="m_name"
                                    name="m_name"
                                    value={formState.m_name}
                                    onChange={e => setFormState(pre => ({ ...pre, m_name: e.target.value }))}
                                    className="border border-[#E1E2E4] rounded-[8px] bg-[white] px-2 py-3 flex-1 min-w-[250px]"
                                    required
                                />
                            </div>
                            <div className="flex items-center flex-wrap gap-y-1">
                                <label htmlFor="m_age" className="min-w-[100px]">
                                    나이
                                </label>
                                <input
                                    type="text"
                                    id="m_age"
                                    name="m_age"
                                    value={formState.m_age}
                                    onChange={e => setFormState(pre => ({ ...pre, m_age: e.target.value }))}
                                    className="border border-[#E1E2E4] rounded-[8px] bg-[white] px-2 py-3 flex-1 min-w-[250px]"
                                    required
                                />
                            </div>
                            <div className="flex items-center flex-wrap gap-y-1">
                                <label htmlFor="m_tel" className="min-w-[100px]">
                                    연락처
                                </label>
                                <PatternFormat
                                    format="###-####-####"
                                    id="m_tel"
                                    name="m_tel"
                                    value={formState.m_tel}
                                    onChange={e => setFormState(pre => ({ ...pre, m_tel: e.target.value }))}
                                    className="border border-[#E1E2E4] rounded-[8px] bg-[white] px-2 py-3 flex-1 min-w-[250px]"
                                    required
                                />
                            </div>
                            <div className="flex items-center flex-wrap gap-y-1">
                                <label htmlFor="m_area" className="min-w-[100px]">
                                    거주지
                                </label>
                                <input
                                    type="text"
                                    id="m_area"
                                    name="m_area"
                                    value={formState.m_area}
                                    onChange={e => setFormState(pre => ({ ...pre, m_area: e.target.value }))}
                                    className="border border-[#E1E2E4] rounded-[8px] bg-[white] px-2 py-3 flex-1 min-w-[250px]"
                                    required
                                />
                            </div>
                            <div className="flex items-center flex-wrap gap-y-1">
                                <label htmlFor="m_car" className="min-w-[100px]">
                                    차랑명
                                </label>
                                <Select
                                    name="m_car"
                                    value={formState.m_car}
                                    onValueChange={value => setFormState(pre => ({ ...pre, m_car: value }))}
                                    required
                                >
                                    <SelectTrigger
                                        id="m_car"
                                        className={`relative shadow-none text-[#1B1C1E] text-[16px] flex gap-[10px] rounded-[8px] focus:ring-2 flex-1 min-w-[250px] border border-[#E1E2E4] bg-white h-[50px]`}
                                    >
                                        <SelectValue placeholder="차량종류 선택" />
                                        <ArrowDown className="[&_path]:fill-[#666666]" />
                                    </SelectTrigger>
                                    <SelectContent className="bg-white">
                                        {cars.map((car, index) => (
                                            <SelectItem key={index} value={car}>
                                                {car}
                                            </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            </div>
                            <div className="flex items-center flex-wrap gap-y-1">
                                <label htmlFor="m_up" className="min-w-[100px]">
                                    해당업무
                                </label>
                                <div className="flex items-center gap-x-5 py-3">
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="radio"
                                            name="m_up"
                                            value="픽업"
                                            onChange={e => setFormState(pre => ({ ...pre, m_up: e.target.value }))}
                                            required
                                        />
                                        <span>픽업</span>
                                    </label>
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="radio"
                                            name="m_up"
                                            value="배송"
                                            onChange={e => setFormState(pre => ({ ...pre, m_up: e.target.value }))}
                                            required
                                        />
                                        <span>배송</span>
                                    </label>
                                </div>
                            </div>
                            <div className="flex items-center flex-wrap gap-y-1">
                                <label htmlFor="m_time" className="min-w-[100px]">
                                    근무시간
                                </label>
                                <div className="flex items-center gap-x-5 py-3">
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="radio"
                                            name="m_time"
                                            value="새벽"
                                            onChange={e => setFormState(pre => ({ ...pre, m_time: e.target.value }))}
                                            required
                                        />
                                        <span>새벽</span>
                                    </label>
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="radio"
                                            name="m_time"
                                            value="오후"
                                            onChange={e => setFormState(pre => ({ ...pre, m_time: e.target.value }))}
                                            required
                                        />
                                        <span>오후</span>
                                    </label>
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="radio"
                                            name="m_time"
                                            value="기타"
                                            onChange={e => setFormState(pre => ({ ...pre, m_time: e.target.value }))}
                                            required
                                        />
                                        <span>기타</span>
                                    </label>
                                </div>
                            </div>
                            <div className="flex items-center flex-wrap gap-y-1">
                                <label htmlFor="contents" className="min-w-[100px]">
                                    기타내용
                                </label>
                                <textarea
                                    id="contents"
                                    name="contents"
                                    value={formState.contents}
                                    onChange={e => setFormState(pre => ({ ...pre, contents: e.target.value }))}
                                    className="border border-[#E1E2E4] rounded-[8px] bg-[white] px-2 py-3 flex-1 min-w-[250px]"
                                    required
                                />
                            </div>
                        </div>
                        <button className="block mx-auto bg-[#264180] p-3 w-full text-white">지원하기</button>
                    </form>
                </div>
            </div>
            <Toaster position="bottom-center" reverseOrder={false} />
        </>
    );
};

export default Recruit;
